/* Pawvela signup slide-in (WELCOME10). Shows once per shopper after a short browse. */
(function () {
  var SEEN = 'pv_wo_seen', DISMISS = 'pv_si_dismissed', PEND = 'pv_si_pending', T0 = 'pv_si_t0';
  var WAIT_MS = 15000, SCROLL_MIN_MS = 6000, SNOOZE_DAYS = 14;
  function lget(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lset(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function sdel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function init() {
    var el = document.getElementById('pv-si'); if (!el) return;
    var s1 = el.querySelector('[data-pv-si-step="1"]'), s2 = el.querySelector('[data-pv-si-step="2"]');
    var form = document.getElementById('pv-si-form'), email = document.getElementById('pv-si-email');
    var err = el.querySelector('.pv-si__err'), shown = false;

    function open(step) {
      s1.hidden = step !== 1; s2.hidden = step !== 2;
      el.hidden = false; shown = true;
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-in'); }); });
    }
    function close(remember) {
      el.classList.remove('is-in');
      setTimeout(function () { el.hidden = true; }, 380);
      if (remember) lset(DISMISS, String(Date.now()));
    }
    function applyCode() {
      lset(SEEN, '1');
      fetch(root + 'discount/WELCOME10', { credentials: 'same-origin' }).catch(function () {});
      fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: 'WELCOME10' }) }).catch(function () {});
    }

    el.querySelectorAll('[data-pv-si-close]').forEach(function (b) { b.addEventListener('click', function () { close(true); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && shown && !el.hidden) close(true); });
    if (form) form.addEventListener('submit', function (e) {
      if (!email.value || !email.checkValidity()) { e.preventDefault(); err.hidden = false; email.focus(); return; }
      sset(PEND, '1');
      var btn = form.querySelector('.pv-si__btn'); if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'One moment…'; }
    });

    /* Coming back from a signup submit. */
    if (sget(PEND)) {
      sdel(PEND);
      var srv = el.querySelector('[data-pv-si-srverr]'), msg = srv ? srv.getAttribute('data-pv-si-srverr') : '';
      if (/[?&]customer_posted=true/.test(location.search) || /taken|already|exists/i.test(msg)) { applyCode(); open(2); return; }
      if (srv) { err.textContent = 'Please check your email address and try again.'; err.hidden = false; open(1); return; }
    }

    /* Banner link ("Get 10% off your first order") opens it on demand. */
    function onDemand() { if (lget(SEEN) && !shown) { open(2); } else { open(1); } setTimeout(function () { if (!s1.hidden) email.focus(); }, 400); }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="pv-signup"]'); if (!a) return;
      e.preventDefault(); onDemand();
    });
    if (/[?&]pv-signup=1/.test(location.search)) { onDemand(); return; }

    /* Automatic show rules. */
    var path = location.pathname;
    if (/\/(cart|checkouts?|account|challenge|password)/.test(path)) return;
    if (lget(SEEN)) return;
    var d = +lget(DISMISS); if (d && Date.now() - d < SNOOZE_DAYS * 864e5) return;
    var t0 = +sget(T0); if (!t0) { t0 = Date.now(); sset(T0, String(t0)); }

    function busy() { return document.querySelector('dialog[open], .pv-dlg[open], [aria-modal="true"]:not(#pv-si)'); }
    function check() {
      if (shown) return;
      var spent = Date.now() - t0;
      var h = document.documentElement, depth = (window.scrollY + window.innerHeight) / Math.max(h.scrollHeight, 1);
      if ((spent >= WAIT_MS || (depth >= 0.5 && spent >= SCROLL_MIN_MS)) && !busy()) { open(1); window.removeEventListener('scroll', check); clearInterval(iv); }
    }
    var iv = setInterval(check, 1000);
    window.addEventListener('scroll', check, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
